import React, { useState, useEffect } from 'react'
import { Dialog, Table, toaster, Button, Heading } from 'evergreen-ui'
import RoundBtn from '../../Components/RoundBtn';
import ExpenseForm from './ExpenseForm';
import axios from '../../Utils/axios';
import { connect } from 'react-redux'
import { setLoading, unsetLoading } from '../../Redux/reducers/loading';
const Expense = ({
  company, dispatch
}) => {

  const [isModalVisible, setVisibility] = useState(false)
  const [expense, setExpense] = useState(null)
  const [expenses, setExpenses] = useState([])

  useEffect(() => {
    getExpenseTypes()
  }, [])

  const getExpenseTypes = async () => {
    try {
      const { data } = await axios.get(`/company/expenses`)
      setExpenses(data.expenses)
    }
    catch (error) {
      toaster.danger('Falha ao buscar despesas')
    }
    finally {

    }
  }

  const createOrEdit = (expense = null) => {
    setExpense(expense)
    setVisibility(true)
  }

  const handleSave = async (expense) => {
    dispatch(setLoading())
    try {
      const { data } = await axios.post(`/company/expenses`, expense)
      setVisibility(false)
      toaster.success(
        'Sucesso ao cadastrar a despesa', {
          duration: 10,
        }
      )

      setExpenses([...expenses, data])
    } catch (error) {

    }
    finally {
      dispatch(unsetLoading())
    }
  }

  const handleUpdate = async ({ __id__, description, active }) => {
    dispatch(setLoading())
    try {
      await axios.put(`/company/expenses/${__id__}`, { description, active })
      await getExpenseTypes()
      setVisibility(false)
      toaster.success(
        'Sucesso ao editar a despesa', {
          duration: 10,
        }
      )
 
    } catch (error) {
      toaster.danger(error.response.data.error.message)
    }
    finally {
      dispatch(unsetLoading())
    }
  }

  return (
    <React.Fragment>
      <Heading size={600} style={{ marginLeft: 10 }}> Despesas </Heading>
      <Table style={{ marginRight: 10, marginLeft: 10, marginTop: 20 }}>
        <Table.Head>
          <Table.TextHeaderCell>
            Descrição das despesas
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Status
          </Table.TextHeaderCell>
          <Table.TextHeaderCell >
            Ações
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.VirtualBody height={600}>
          {expenses.map(expense => (
            <Table.Row key={expense.__id__}>
              <Table.TextCell >{expense.description}</Table.TextCell>
              <Table.TextCell>{expense.active ? 'Ativo' : 'Inativo'}</Table.TextCell>
              <Table.TextCell>
                <Button
                  iconBefore='edit'
                  marginRight={10}
                  onClick={() => createOrEdit(expense)}
                > Editar </Button>
              </Table.TextCell>
            </Table.Row>
          ))}
        </Table.VirtualBody>
      </Table >
      <RoundBtn action={() => createOrEdit()} />

      <Dialog
        shouldCloseOnOverlayClick={false}
        isShown={isModalVisible}
        title="Cadastro de Despesas"
        onCloseComplete={() => setVisibility(false)}
        hasFooter={false}
      >
        <ExpenseForm
          expense={expense}
          save={(expense) => handleSave(expense)}
          update={(expense) => handleUpdate(expense)}
        />
      </Dialog>

    </React.Fragment >
  )
}

const mapStateToProps = ({ auth }) => ({
  company: auth.account
})
export default connect(mapStateToProps)(Expense)